import React from 'react';
import { Button } from './ui/Button';
import { Check, Lock } from 'lucide-react';
export function PricingSection() {
  const handlePurchase = () => {
    window.location.href = 'https://checkout.rincondigital.shop/cart/53324019826963:1';
  };
  return <section id="pricing" className="py-20 bg-gradient-to-b from-amber-50 to-white" data-id="element-66">
      <div className="container mx-auto px-4" data-id="element-67">
        <div className="max-w-5xl mx-auto" data-id="element-68">
          {/* Single Pricing Block */}
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-amber-100" data-id="element-69">
            <div className="bg-blue-900 p-6 text-center text-amber-400" data-id="element-70">
              <h2 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-71">
                OFERTA ESPECIAL LIMITADA
              </h2>
              <p className="text-amber-200" data-id="element-72">
                Acceso completo de por vida + Todos los bonos
              </p>
            </div>

            {/* Product Image - Inside the module */}
            <div className="py-8 px-4" data-id="element-73">
              <img src="https://cdn.magicpatterns.com/uploads/tMZG5rVVPzna4TQY49K55p/mockup_principal_derecho_360.png" alt="Derecho 360 Pack Completo" className="w-full max-w-lg mx-auto drop-shadow-2xl" data-id="element-74" />
            </div>

            <div className="p-8 md:p-12 pt-0" data-id="element-75">
              <div className="grid md:grid-cols-2 gap-12" data-id="element-76">
                {/* Left: What's included */}
                <div className="space-y-6" data-id="element-77">
                  <h3 className="text-2xl font-bold text-slate-900" data-id="element-78">
                    ¿Qué incluye tu acceso?
                  </h3>
                  <ul className="space-y-4" data-id="element-79">
                    {['Sistema completo DERECHO 360', 'Clases listas paso a paso', 'Actividades para adolescentes', 'BONO 1: Mapa Anual de Derecho', 'BONO 2: Evaluaciones Prácticas', 'BONO 3: Casos Reales', 'Actualizaciones futuras gratis', 'Soporte prioritario'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-80">
                        <div className="bg-green-100 rounded-full p-1 flex-shrink-0" data-id="element-81">
                          <Check className="h-4 w-4 text-green-600" data-id="element-82" />
                        </div>
                        <span className="text-slate-700 font-medium" data-id="element-83">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>

                {/* Right: Pricing */}
                <div className="flex flex-col justify-center" data-id="element-84">
                  <div className="text-center mb-8" data-id="element-85">
                    <p className="text-slate-500 font-medium mb-2" data-id="element-86">
                      Precio Regular
                    </p>
                    <p className="text-3xl text-slate-400 line-through mb-6" data-id="element-87">
                      $49.990
                    </p>

                    <p className="text-sm text-blue-900 font-bold uppercase tracking-wider mb-2" data-id="element-88">
                      Hoy solo por
                    </p>
                    <p className="text-6xl md:text-7xl font-extrabold text-blue-900 mb-8" data-id="element-89">
                      $19.990
                    </p>
                  </div>

                  <Button onClick={handlePurchase} size="xl" fullWidth className="mb-6 shadow-xl" data-id="element-90">
                    QUIERO ACCESO AHORA
                  </Button>

                  <div className="space-y-3 text-center" data-id="element-91">
                    <div className="flex items-center justify-center gap-2 text-sm text-slate-500" data-id="element-92">
                      <Lock className="h-4 w-4" data-id="element-93" />
                      <span data-id="element-94">Pago 100% seguro y encriptado</span>
                    </div>
                    <p className="text-xs text-slate-400" data-id="element-95">
                      Aceptamos todos los medios de pago
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Guarantee Section */}
          <div className="mt-8 bg-green-50 p-8 rounded-2xl text-center border-2 border-green-100 max-w-3xl mx-auto" data-id="element-96">
            <div className="max-w-2xl mx-auto" data-id="element-97">
              <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-98">
                Garantía de Satisfacción Total
              </h3>
              <p className="text-slate-700 text-lg leading-relaxed" data-id="element-99">
                Pruébalo 7 días. Si no cumple tus expectativas, te devolvemos el
                100% de tu dinero. Sin preguntas, sin complicaciones.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}